import { createContext, useContext, useState } from "react";

const CheckinCtx = createContext(null);

export function CheckinProvider({ children }) {
  const [flow, setFlow] = useState({
    parent: null,
    children: [],
    selected: [],
    result: null,
    needsConsent: false,
  });
  const update = (patch) => setFlow((prev) => ({ ...prev, ...patch }));
  const reset = () =>
    setFlow({ parent: null, children: [], selected: [], result: null, needsConsent: false });
  return (
    <CheckinCtx.Provider value={{ flow, update, reset }}>
      {children}
    </CheckinCtx.Provider>
  );
}

export const useCheckin = () => useContext(CheckinCtx);
